import { GeneratedLocale } from '@/pages/LessonEditor/types';
import { Box, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContextInterface } from '../IContext';

class FillInTheBlankContextClass implements FillInTheBlankContext {
    type: 'fill_in_the_blank';
    answer?: string;
    locale?: GeneratedLocale;

    constructor(context: FillInTheBlankContext) {
        this.type = context.type;
        this.answer = context.answer;
        this.locale = context.locale;
    }

    isSufficient(): boolean {
        return !!this.answer;
    }
}

export interface FillInTheBlankContext extends ContextInterface {
    type: 'fill_in_the_blank';
    answer?: string;
    locale?: GeneratedLocale;
}

export const FillInTheBlankPanel = ({ value, onChange }: { value: FillInTheBlankContext; onChange?: (value: FillInTheBlankContext) => void }) => {
    const { t } = useTranslation();

    const [answer, setAnswer] = useState(value.answer || '');
    const [generatedLocale, setGeneratedLocale] = useState<GeneratedLocale>('zh-Hant');

    return (
        <Stack spacing={2}>
            <Box>
                <TextField
                    label={t('experiment.generator.question.label.answer')}
                    fullWidth
                    placeholder={t('experiment.generator.question.label.answer')}
                    value={answer}
                    onChange={(e) => {
                        setAnswer(e.target.value);
                        onChange?.(new FillInTheBlankContextClass({ type: 'fill_in_the_blank', answer: e.target.value, locale: generatedLocale }));
                    }}
                />
            </Box>

            <Box>
                <FormControl fullWidth>
                    <InputLabel>{t('experiment.generator.question.label.languageVariant')}</InputLabel>
                    <Select
                        label={t('experiment.generator.question.label.languageVariant')}
                        fullWidth
                        value={generatedLocale}
                        onChange={(e) => {
                            setGeneratedLocale(e.target.value as GeneratedLocale);
                            onChange?.(new FillInTheBlankContextClass({ type: 'fill_in_the_blank', answer: answer, locale: e.target.value as GeneratedLocale }));
                        }}
                    >
                        <MenuItem value='zh-Hant'>{t('experiment.generator.question.languageVariant.traditional')}</MenuItem>
                        <MenuItem value='zh-Hans'>{t('experiment.generator.question.languageVariant.simplified')}</MenuItem>
                    </Select>
                </FormControl>
            </Box>
        </Stack>
    );
};
